import React from 'react';
import PropTypes from 'prop-types';
import {
	ListItem,
	FormControlLabel,
	Grid,
	Typography,
	Radio,
} from '@material-ui/core';
import MadaIcon from './components/MadaIcon';
import VisaIcon from './components/VisaIcon';
import MastercardIcon from './components/MastercardIcon';

import useStyles from './styles';
import { useIsDesktop } from 'components/utilities';

const PaymentMethodListItem = ({
	icon: Icon,
	title,
	value,
	cardIcon = false,
}) => {
	const classes = useStyles();

	const isDesktop = useIsDesktop();

	const paymentMethodIconsClassName = isDesktop
		? null
		: classes.paymentMethodListItem;

	return (
		<ListItem>
			<FormControlLabel
				classes={{
					root: classes.root,
					label: classes.label,
				}}
				label={
					<Grid
						container
						spacing={1}
						justify="space-between"
						alignItems="center"
						wrap="nowrap"
					>
						<Grid item xs="auto">
							<Grid container alignItems="center" wrap="nowrap">
								<Typography variant={isDesktop ? 'body1' : 'h6'}>
									{title}
								</Typography>
								{cardIcon && (
									<Grid>
										<Grid container alignItems="center" wrap="nowrap">
											<MadaIcon className={paymentMethodIconsClassName} />
											<VisaIcon className={paymentMethodIconsClassName} />
											<MastercardIcon className={paymentMethodIconsClassName} />
										</Grid>
									</Grid>
								)}
							</Grid>
						</Grid>
						<Grid item xs="auto" className={classes.icon}>
							<Icon
								fontSize={isDesktop ? 'large' : 'default'}
								color="primary"
							/>
						</Grid>
					</Grid>
				}
				control={<Radio color="primary" value={value} />}
			/>
		</ListItem>
	);
};

PaymentMethodListItem.propTypes = {
	icon: PropTypes.elementType,
	title: PropTypes.string,
	value: PropTypes.string,
};

export default PaymentMethodListItem;
